<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">
			交易管理>抖音订单管理>抖音订单详情
		</div>
		<div class="newADcontent">
			<div class="adContent">
				<div class="title" style="margin-top: 20px;">
					<div class="blue"></div>
					<div style="flex: 1;">抖音订单信息</div>
				</div>
				<el-form ref="form" label-position="left">
					<el-form-item>
						<div class="list">
							<div>
								<span>订单编号</span>
								<span>{{ order.orderNo }}</span>
							</div>
							<div>
								<span>抖音内部订单编号</span>
								<span>{{ order.dyOrderId }}</span>
							</div>
							<div>
								<span>商品/服务</span>
								<span>{{ order.type }}</span>
							</div>
							<div>
								<span>订单类型</span>
								<span>{{ order.orderType|typeFormat }}</span>
							</div>
							<div>
								<span>订单状态</span>
								<span>{{order.status| statusFormat}}</span>
							</div>
							<div>
								<span>下单时间</span>
								<span>{{ order.addTime==null?'/': order.addTime}}</span>
							</div>
							<div>
								<span>付款时间</span>
								<span>{{ order.payTime ==null?'/':order.payTime}}</span>
							</div>
						</div>
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">订单信息</div>
					</div>
					<el-form-item>
						<div class="list">
							<div>
								<span>服务门店</span>
								<span>{{ order.storeName }}</span>
							</div>
							<div>
								<span>发型师</span>
								<span>{{ order.workerName }}</span>
							</div>

							<div style="margin-top: -10px;display: flex;">
								<div>备注</div>
								<div style="margin-left: -10px;"><el-input v-model="editData.remark" type="textarea"
										style="width: 180px;"></el-input></div>
							</div>
						</div>
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">用户信息</div>
					</div>
					<el-form-item>
						<div class="list">
							<div>
								<span>用户昵称</span>
								<span>{{ order.nickName }}</span>
							</div>
							<div>
								<span>联系电话</span>
								<span>{{ order.telphone }}</span>
							</div>
							<div>
								<span>用户类型</span>
								<span>{{ order.userType }}</span>
							</div>
						</div>
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">支付信息</div>
					</div>
					<el-form-item>
						<div class="list">
							<div>
								<span>支付方式</span>
								<span>{{ order.payType }}</span>
							</div>
							<div>
								<span>参与活动</span>
								<span>{{ order.inActivity }}</span>
							</div>
							<div>
								<span>优惠减免</span>
								<span>{{ order.couponTotal }}</span>
							</div>
							<div>
								<span>支付总额</span>
								<span>{{ order.payTotal }}</span>
							</div>
						</div>
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">退款信息</div>
					</div>
					<el-form-item>
						<div class="list">
							<div>
								<span>退款申请</span>
								<span
									v-if="order.status != -2 && order.refundResult==null || order.refundResult==0">无退款申请</span>
								<el-select v-else="order.status == -2" v-model="editData.refundResult"
									placeholder="退款待审核" style="width: 150px;" clearable>
									<el-option v-for="item in refundResultList" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
								<div v-if="editData.refundResult==2" style="display: flex;">
									<span>拒绝原因</span>
									<div><el-input v-model="editData.message" type="text"
											style="width: 150px;"></el-input></div>
								</div>
							</div>
							<div>
								<span>退款结果</span>
								<span v-if="order.refundId">
									{{orderStatus.refund_status | refundStatusFormat }}
								</span>
							</div>
							<div>
								<span>退款审核状态</span>
								<span v-if="order.refundId">
									{{orderStatus.merchant_audit_detail.audit_status | auditStatusFormat}}
								</span>
							</div>
							<div>
								<span>退款来源</span>
								<span>{{ order.refundSource| refundSourceFormat}}</span>
							</div>
							<div>
								<span>退款原因</span><el-input v-model="order.refundReason" type="textarea"
									style="width: 150px;"></el-input>
							</div>
							<!-- <div>
		  				  	<span>退款金额</span><el-input v-model="editData.remark" type="text" style="width: 100px;"></el-input> 元
		  				</div> -->
						</div>
					</el-form-item>
					<el-form-item>
						<router-link to="/dyManagement"><el-button type="primary" style="margin-left:30%;"
								@click="reload()">取 消</el-button></router-link>
						<el-button type="primary" style="margin-left:10%;" @click="edit()">确 定</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	// var script = document.createElement('script');
	// script.type = 'text/javascript';
	// script.src = 'https://cj.ciaojian.com/bytedance/order/query_order?orderId=ots71847306969913613377777';
	// document.head.appendChild(script);
	export default {
		data() {
			return {
				id: "",
				orderNo: "",
				order: {},
				orderStatus: {},
				tableData: [],
				refundResultList: [{
					label: "允许退款",
					value: 1,
				}, {
					label: "拒绝退款",
					value: 2,
				}],
				editData: {}
			};
		},
		filters: {
			typeFormat(val) {
				switch (val) {
					case "1":
						return "普通订单";
					case "3":
						return "次卡订单";
					case "10":
						return "染发次卡订单";
					case "5":
						return "膨胀券订单";
					case "6":
						return "会员订单";
					case "7":
						return "会员续费订单";
					case "9":
						return "美团订单";
					case "2":
						return "企业剪订单";
					case "11":
						return "权益订单";
					default:
						return "/";
				}
			},
			statusFormat(val) {
				switch (val) {
					case 0:
						return "待支付";
					case 1:
						return "订单处理中";
					case 2:
						return "取消订单";
					case 3:
						return "已支付待发券";
					case 4:
						return "已发券";
					case 1:
						return "用户超时未支付";
					case -2:
						return "退款申请";
					case -3:
						return "退款成功";
					default:
						return "/";
				}
			},
			refundSourceFormat(val) {
				switch (val) {
					case 1:
						return "用户发起退款";
					case 3:
						return "次卡过期自动退款订单";
					case 4:
						return "客户退款";
					case 5:
						return "预约失败或预约取消自动退款";
					default:
						return "无";
				}
			},
			refundStatusFormat(val) {
				switch (val) {
					case val = "SUCCESS":
						return "退款成功";
					case val = "PROCESSING":
						return "退款中";
					case val = "FAIL":
						return "退款失败";
					default:
						return "其他";
				}
			},
			auditStatusFormat(val) {
				switch (val) {
					case val = "INIT":
						return "初始化";
					case val = "TOAUDIT":
						return "待审核";
					case val = "AGREE":
						return "同意";
					case val = "DENY":
						return "拒绝";
					case val = "OVERTIME":
						return "超时未审核自动同意";
					default:
						return "其他";
				}
			}
		},
		methods: {
			reload() {
				this.editData = JSON.parse(JSON.stringify(this.order));
			},
			getOrder() {
				this.$http.get("dDyOrder/details?id=" + this.id).then(res => {
					this.order = res.body.data;
					console.log(this.order)
					this.editData = JSON.parse(JSON.stringify(this.order));
					if (res.body.data.refundId != null) {
						this.$http.get("https://cj.ciaojian.com/bytedance/pay/query_refund?orderNo=" + this.order
							.refundId).then(res => {
							this.orderStatus = res.body.data;
						})
					}
				});
			},
			edit() {
				if ((this.order.refundResult != this.editData.refundResult) || (this.order.remark != this.editData
						.remark) || (this.order.message != this.editData.message)) {
					this.$http.get("https://cj.ciaojian.com/bytedance/pay/merchant_audit?outRefundNo=" + this.order
						.orderNo + "&status=" + this.editData.refundResult + "&message=" + this.editData.message).then(
						res => {

						})
				}
				this.$router.push({
					path: '/dyManagement'
				});
			}
		},
		computed: {
			statusFomcat() {
				return (val) => {
					var result;
					this.orderStateList.forEach(ele => {
						if (ele.value == val) result = ele.label;
					});
					return result;
				}
			}
		},
		mounted() {
			this.id = this.$route.query.id;
			// this.orderNo = this.$route.query.orderNo;
			this.getOrder();
		}
	};
</script>

<style lang="less" scoped>
	p {
		margin: 0;
		padding: 0;
	}

	.list {
		display: flex;
		flex-wrap: wrap;

		div {
			width: 25%;

			span {
				margin-right: 15px;
			}
		}
	}

	.list2 {
		width: 100%;
		display: flex;

		>div {
			flex: 1;

			&:nth-child(1) {
				margin-right: 25px;
			}
		}
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}

	/deep/ .tabelContent .el-checkbox__label {
		display: none;
	}
</style>